export default __webpack_public_path__ + "static/media/mtc-logo.dd29fa93.svg";